
import { PermissionsEnum } from "@/auth/interfaces";
import { SavePorcentajeIvaRetBienes } from "../../shared/components/savePorcentajeRetIvaBienees";
import { useCheckPermissions } from "@/shared";

export interface CreatePorcentajeIvaPageInterface {}

const CreatePorcentajeIvaBienesPage: React.FC<CreatePorcentajeIvaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_porcentajeretivabienes);

  return <SavePorcentajeIvaRetBienes titlePage="Crear Porcentaje IVA Retenido en Bienes" />;
};

export default CreatePorcentajeIvaBienesPage;
